<template>
    <div class="ttmotif">
        <router-link to="/">
            <div class="svg-holder">
                <inline-svg
                    class="tt-motif-svg"
                    src="/assets/site/images/tt-motif.svg"
                    aria-label="ARSONAL"
                ></inline-svg>
            </div>
        </router-link>
    </div>

</template>
<script>
export default {
    name: "TTMotif",
    components: {}
}
</script>
